import { useQuery } from '@tanstack/react-query';
import { fetchActiveCurrencyTypes } from '../../../../api/administration/financeSettings/currencyTypes';

export const useActiveCurrencyTypes = (options = {}) => {
  const query = useQuery({
    queryKey: ['currencyTypes', 'active'],
    queryFn: () => fetchActiveCurrencyTypes(),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    currencyTypes: query.data?.data?.currencyTypes ?? [],
  };
};

export default useActiveCurrencyTypes;
